// Iter 617 — Isi/Lengkapi Titik oleh Operator Bordir pelaksana (cadangan bila titik/pcs tidak terbaca otomatis).
import React, { useEffect, useState } from "react";
import axios from "axios";
import { createPortal } from "react-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const num = (v) => (v === "" || v === null || v === undefined ? "" : String(v).replace(/\D/g, "").slice(0, 4));

function Row({ label, sub, children, tid }) {
  return <div className="opb-card" data-testid={tid} style={{ padding: 10 }}>
    <div style={{ fontWeight: 600 }}>{label}</div>
    {sub && <div className="lb-row-sub">{sub}</div>}
    <div style={{ display: "flex", gap: 8, alignItems: "center", marginTop: 6, flexWrap: "wrap" }}>{children}</div>
  </div>;
}

const inputStyle = { width: 84, fontSize: 16, padding: "8px 10px" };

export function TitikInputSheet({ kind, refId, onClose, onSaved, tid = "titik-sheet" }) {
  const [form, setForm] = useState(null);
  const [err, setErr] = useState("");
  const [vals, setVals] = useState({});
  const [lines, setLines] = useState([{ pcs: "", titik: "" }]);
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [confirm, setConfirm] = useState(false);
  useEffect(() => {
    axios.get(`${API}/bordir-tasks/titik-form`, { params: { kind, ref_id: refId }, withCredentials: true })
      .then(r => {
        setForm(r.data);
        setVals(Object.fromEntries((r.data.items || []).filter(x => x.titik_auto === null).map(x => [x.key, x.titik_manual || ""])));
        if (r.data.lines?.length) setLines(r.data.lines.map(x => ({ pcs: x.pcs, titik: x.titik })));
      })
      .catch(e => setErr(e?.response?.data?.detail || e.message));
  }, [kind, refId]);
  const editing = form?.has_manual;
  const save = async () => {
    setBusy(true); setErr("");
    try {
      const body = form.needs_pcs
        ? { kind, ref_id: refId, lines: lines.filter(l => l.pcs && l.titik).map(l => ({ pcs: +l.pcs, titik: +l.titik })), reason }
        : { kind, ref_id: refId, items: Object.entries(vals).filter(([, v]) => v).map(([key, v]) => ({ key, titik: +v })), reason };
      const r = await axios.post(`${API}/bordir-tasks/titik-manual`, body, { withCredentials: true });
      window.dispatchEvent(new Event("bordir-progress-saved"));
      onSaved && onSaved(r.data);
      onClose();
    } catch (e) {
      // Iter 639 — pesan mudah dipahami; angka input tetap (form tidak ditutup, tidak ada status berhasil).
      const st = e?.response?.status;
      const d = e?.response?.data?.detail;
      setErr(st >= 500 || !st ? "Penyimpanan gagal karena gangguan server/jaringan. Angka Anda masih tersimpan di form — silakan tekan Konfirmasi Simpan lagi." : (typeof d === "string" ? d : "Penyimpanan gagal. Periksa kembali isian Anda."));
    } finally { setBusy(false); }
  };
  const oldPcs = form ? (form.needs_pcs ? (form.lines || []).reduce((n, l) => n + l.pcs, 0) || null : form.pcs_auto) : null;
  const oldTotal = form ? (form.needs_pcs ? (form.lines || []).reduce((n, l) => n + l.pcs * l.titik, 0)
    : (form.items || []).reduce((n, x) => n + x.qty * (+(x.titik_auto ?? x.titik_manual) || 0), 0)) : 0;
  const newPcs = form?.needs_pcs ? lines.reduce((n, l) => n + (+l.pcs || 0), 0) : form?.pcs_auto;
  const total = form?.needs_pcs ? lines.reduce((n, l) => n + (+l.pcs || 0) * (+l.titik || 0), 0)
    : (form?.items || []).reduce((n, x) => n + x.qty * (+(x.titik_auto ?? vals[x.key]) || 0), 0);
  return createPortal(<div className="leaderboard-bordir opb-sheet" role="dialog" aria-modal="true" data-testid={tid}>
    <div className="opb-sheet-head">
      <b>{editing ? "Ubah Titik" : "Isi Jumlah Titik"}{form ? ` · ${form.order_number}` : ""}{form?.marketplace && form.marketplace !== "Shopee" ? ` · ${form.marketplace}` : ""}</b>
      <button type="button" className="soft-btn small-btn" onClick={onClose} data-testid={`${tid}-close`}>Nanti</button>
    </div>
    <div className="opb-sheet-body opb">
      {!form && !err && <div className="lb-row-sub">Memuat…</div>}
      {err && <div className="warn-box small" data-testid={`${tid}-error`}>{err}</div>}
      {form && form.needs_pcs && <>
        <div className="lb-row-sub" data-testid={`${tid}-pcs-reason`}>Pcs belum tercatat otomatis ({form.pcs_reason || "data pesanan tidak tersedia"}). Isi pakaian yang Anda kerjakan.</div>
        {lines.map((l, i) => <Row key={i} label={`Produk ${i + 1}`} tid={`${tid}-line-${i}`}>
          <input inputMode="numeric" placeholder="Pcs" value={l.pcs} style={inputStyle} data-testid={`${tid}-line-${i}-pcs`}
            onChange={e => setLines(lines.map((x, j) => j === i ? { ...x, pcs: num(e.target.value) } : x))}/>
          <span>pcs ×</span>
          <input inputMode="numeric" placeholder="Titik" value={l.titik} style={inputStyle} data-testid={`${tid}-line-${i}-titik`}
            onChange={e => setLines(lines.map((x, j) => j === i ? { ...x, titik: num(e.target.value) } : x))}/>
          <span>titik</span>
        </Row>)}
        <button type="button" className="soft-btn small-btn" onClick={() => setLines([...lines, { pcs: "", titik: "" }])} data-testid={`${tid}-add-line`}>+ Produk lain (titik berbeda)</button>
      </>}
      {form && !form.needs_pcs && form.items.map(x => <Row key={x.key} label={`${x.name} · ${x.qty} pcs`} sub={x.variation} tid={`${tid}-item-${x.key.split("|")[0]}`}>
        {x.titik_auto !== null ? <span className="lb-row-sub">Titik otomatis: <b>{x.titik_auto}</b> per pakaian</span> : <>
          <input inputMode="numeric" placeholder="Titik" value={vals[x.key] || ""} style={inputStyle} data-testid={`${tid}-item-${x.key.split("|")[0]}-titik`}
            onChange={e => setVals({ ...vals, [x.key]: num(e.target.value) })}/>
          <span>titik per pakaian</span></>}
      </Row>)}
      {form && <input placeholder={editing ? "Alasan perubahan + bukti (wajib), mis. 'SPK fisik foto 15/10'" : "Sumber/bukti titik (wajib), mis. 'mockup v2', 'SPK fisik'"} value={reason} onChange={e => setReason(e.target.value)}
        style={{ fontSize: 16, padding: "8px 10px" }} data-testid={`${tid}-reason`}/>}
      {form && (form.history || []).length > 0 && <div className="opb-card" style={{ padding: 10 }} data-testid={`${tid}-audit`}>
        <div style={{ fontWeight: 600 }}>Riwayat pengisian titik</div>
        {form.history.slice().reverse().map((h, i) => <div key={i} className="lb-row-sub" data-testid={`${tid}-audit-${i}`}>
          {new Date(h.at).toLocaleString("id-ID", { timeZone: "Asia/Jakarta" })} · {h.by_name || "-"} ({h.by_role === "owner_admin" ? "Owner/Admin" : "Operator"}){h.correction ? " · Koreksi" : ""} — bukti: {h.reason || "(tanpa keterangan, catatan lama)"}</div>)}
      </div>}
      {form && <div className="lb-row-sub" data-testid={`${tid}-total`}>Total satuan titik: <b>{total}</b></div>}
      {form && confirm && <div className="opb-card" style={{ padding: 10 }} data-testid={`${tid}-confirm`}>
        <div style={{ fontWeight: 600 }}>Periksa sebelum disimpan</div>
        <div className="lb-row-sub" data-testid={`${tid}-old`}>Nilai lama: {oldPcs ?? "—"} pcs · {oldTotal || "—"} satuan titik</div>
        <div className="lb-row-sub" data-testid={`${tid}-new`}>Nilai baru: <b>{newPcs ?? "—"} pcs · {total} satuan titik</b></div>
        {form.by_admin && <div className="lb-row-sub">Koreksi dicatat atas nama Anda (Owner/Admin) beserta waktunya.</div>}
      </div>}
      {form && (confirm
        ? <div style={{ display: "flex", gap: 8 }}>
            <button type="button" className="soft-btn" onClick={() => setConfirm(false)} data-testid={`${tid}-back`}>Ubah Lagi</button>
            <button type="button" className="primary" disabled={busy} onClick={save} data-testid={`${tid}-save`}>{busy ? "Menyimpan…" : "Konfirmasi Simpan"}</button></div>
        : <button type="button" className="primary" disabled={!total || reason.trim().length < 5} onClick={() => setConfirm(true)} data-testid={`${tid}-review`}>Simpan Titik</button>)}
    </div>
  </div>, document.body);
}

export default TitikInputSheet;
